import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SignupMiddlewareComponent } from './signup-middleware/signup-middleware.component';
import { AuthConnectComponent } from './auth-connect/auth-connect.component';
import { SignupResolverService } from './service/signup-resolver.service';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: 'signupredirect',
        component: SignupMiddlewareComponent
      },
      {
        path:'logout',
        redirectTo:'support/logout'
      },
      {
        path: ':page',
        component: AuthConnectComponent,
        resolve: { 'signup': SignupResolverService}
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
